// extracted by mini-css-extract-plugin
export default {"editContainer":"EditableComponent_editContainer__hDXPD","editButton":"EditableComponent_editButton__TlNrh"};